export default "__VITE_ASSET__Cv$LtpqA__"